import type { PayLinkView } from '@lipaflow/portal-core'

/**
 * Rental's note on the payment link page (Tier 2): in apartments where the
 * manager bills service charge and water and the owner collects rent, say so,
 * so a renter does not wonder why rent is missing.
 */
export function rentalPayLinkNotice(view: PayLinkView): string | null {
  const billsRent = view.invoices.some((invoice) => invoice.lines.some((line) => line.category === 'rent'))
  return billsRent ? null : `Rent for this ${view.entity_label.toLowerCase()} is paid to your landlord, not through this link.`
}
